import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { HR, HRListResponse, WidgetRegionJobDTO } from './HRVacancies.type';
import { AxiosResponse } from 'axios';

let listRequest: any = null;

const REQUEST = 'widget/user-region-job';

export const hrControlService = {
  getList: (region_id: number, params: any): Promise<AxiosResponse<HRListResponse>> => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase(`${REQUEST}/${region_id}`), {
      cancelToken: listRequest.token,
      params,
    });
  },

  update: ({id, comment}: {id: number; comment: Pick<WidgetRegionJobDTO, 'comment'>}): Promise<AxiosResponse<HR>> => {
    return axios.put(getEndpointBase(`${REQUEST}/${id}`), { comment });
  },
  
  delete: (id: number): Promise<AxiosResponse<void>> => {
    return axios.delete(getEndpointBase(`${REQUEST}/${id}`))
  },

  add: (data: WidgetRegionJobDTO): Promise<AxiosResponse<HR>> => {
    return axios.post(getEndpointBase(REQUEST), data)
  },
};
